const devBaseURL = 'https://0f266ced4f0d48e2a244eb79dec2490e.apig.cn-north-4.huaweicloudapis.com';
// const proBaseURL = 'https://production.org';


// export const BASE_URL = process.env.NODE_ENV === 'development' ? devBaseURL: proBaseURL;
export const BASE_URL = devBaseURL;

export const TIMEOUT = 5000